import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fe63354"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "zygcfxselect" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 报告期 ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "按产品分")
], -1))
const _hoisted_5 = {
  key: 1,
  style: {"height":"150px","margin-left":"-16px"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "按地区分")
], -1))
const _hoisted_7 = {
  key: 1,
  style: {"height":"150px","margin-left":"-16px"}
}
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_Charts = _resolveComponent("Charts")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, {
    tip: "加载中...",
    spinning: _ctx.spinning
  }, {
    default: _withCtx(() => [
      (_ctx.hasData)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_a_select, {
                value: _ctx.selectedReport,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedReport) = $event)),
                style: {"width":"200px"},
                onChange: _ctx.handleChange,
                size: "small",
                getPopupContainer: _ctx.getPopupContainer
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportOptions, (item, i) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: 'zygcfx' + i,
                      value: item.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "onChange", "getPopupContainer"])
            ]),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _hoisted_4,
                (_ctx.currentProductData.length)
                  ? (_openBlock(), _createBlock(_component_Charts, {
                      key: 0,
                      colorList: { color: _ctx.theme == 'dark' ? '#d7d7df' : '#8c94a8' },
                      id: "productChart",
                      option: _ctx.productChartOption
                    }, null, 8, ["colorList", "option"]))
                  : (_openBlock(), _createElementBlock("section", _hoisted_5, [
                      _createVNode(_component_Nodata, {
                        mode: "vertical",
                        customdesc: '暂无数据'
                      })
                    ]))
              ]),
              _createElementVNode("li", null, [
                _hoisted_6,
                (_ctx.currentRegionData.length)
                  ? (_openBlock(), _createBlock(_component_Charts, {
                      key: 0,
                      colorList: { color: _ctx.theme == 'dark' ? '#d7d7df' : '#8c94a8' },
                      id: "regionChart",
                      option: _ctx.regionChartOption
                    }, null, 8, ["colorList", "option"]))
                  : (_openBlock(), _createElementBlock("section", _hoisted_7, [
                      _createVNode(_component_Nodata, {
                        mode: "vertical",
                        customdesc: '暂无数据'
                      })
                    ]))
              ])
            ]),
            _createVNode(_component_a_table, {
              "data-source": _ctx.mergedTableData,
              columns: _ctx.columns,
              pagination: false,
              bordered: true,
              size: "middle",
              "row-key": "key"
            }, null, 8, ["data-source", "columns"])
          ]))
        : (_openBlock(), _createElementBlock("section", _hoisted_8, [
            _createVNode(_component_Nodata, {
              nodatadesc: _ctx.itemdata.title
            }, null, 8, ["nodatadesc"])
          ]))
    ]),
    _: 1
  }, 8, ["spinning"]))
}